module.exports = __webpack_public_path__ + "static/media/edinburgh-28.df5ab02d.jpg";